module.exports = __webpack_public_path__ + "static/media/telefunken_bg.ffc14931.png";